"use client";

import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import clsx from "clsx";
import WaveDropActionsAddReaction from "./WaveDropActionsAddReaction";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropReactions from "./WaveDropReactions";
import { getReactionCount } from "./reaction-utils";
interface CurationDropFooterProps {
  readonly drop: ExtendedDrop;
  readonly className?: string | undefined;
}
export default function CurationDropFooter(t0) {
  const $ = _c(18);
  const {
    drop,
    className
  } = t0;
  let t1;
  if ($[0] !== drop.reactions) {
    t1 = drop.reactions.some(_temp);
    $[0] = drop.reactions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasVisibleReactions = t1;
  let t2;
  if ($[2] !== className) {
    t2 = clsx("tw-relative tw-z-20 tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-3 tw-gap-y-2", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== drop || $[5] !== hasVisibleReactions) {
    t3 = hasVisibleReactions && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1"><WaveDropReactions drop={drop} /></div>;
    $[4] = drop;
    $[5] = hasVisibleReactions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== drop) {
    t4 = <div className="tw-mt-1 tw-flex tw-size-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-dashed tw-border-iron-700/80 tw-bg-iron-900/20 tw-transition-colors tw-duration-200 desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-bg-iron-900/40"><WaveDropActionsAddReaction drop={drop} size="compact" updateCurationCache={true} /></div>;
    $[7] = drop;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== drop) {
    t6 = <div className="tw-ml-2 tw-mt-1 tw-flex tw-size-9 tw-flex-shrink-0 tw-items-center tw-justify-center tw-text-iron-500 desktop-hover:hover:tw-text-iron-300"><WaveDropActionsCopyLink drop={drop} size="compact" /></div>;
    $[12] = drop;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className={t2} data-text-selection-exclude="true">{t5}{t6}</div>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp(reaction) {
  return getReactionCount(reaction) > 0;
}